import { EMPTY_OBJECT } from '../../../../constants/common'
import {
  FILTER_NAME_SUB_MENU,
  MANAGER_FILTER_NAME,
  STATUS_FILTER_NAME,
  TASK_STATUS_FILTER_NAME,
  TASK_STATUS_FILTER_OPEN,
} from '../../../../constants/filter'
import { SUBMENU_DEFAULT_VALUE } from '../../../../constants/route'
import { isTaskDone, isTaskDoneCommitType } from '../../../Task'
import { BIRDVIEW_META_SEPARATOR } from '../../DashboardBirdview.constants'
import { BIRDVIEW_DOC_FLOW_OPEN_STATUSES } from '../../DashboardBirdview.constants.api'
import { checkIsBirdviewTeamScope } from '../../DashboardBirdview.utils'

function checkCanToggleBirdviewActivity(activity) {
  return (
    isTaskDoneCommitType(activity) &&
    (isTaskDone(activity)
      ? activity.permissions.can_mark_as_open
      : activity.permissions.can_mark_as_done)
  )
}

// Activities have no `staff_member` filter of their own, so the manager field
// carries the personal scope.
export function getBirdviewActivitiesFilters({ scope, userId }) {
  return {
    ...(checkIsBirdviewTeamScope(scope)
      ? EMPTY_OBJECT
      : { [MANAGER_FILTER_NAME]: [userId] }),
    [FILTER_NAME_SUB_MENU]: SUBMENU_DEFAULT_VALUE,
    [TASK_STATUS_FILTER_NAME]: [TASK_STATUS_FILTER_OPEN],
  }
}

export function toBirdviewActivityItem(activity) {
  return {
    address: [activity.building?.title, activity.request?.title]
      .filter(Boolean)
      .join(BIRDVIEW_META_SEPARATOR),
    canToggleDone: checkCanToggleBirdviewActivity(activity),
    deadline: activity.deadline,
    done: isTaskDone(activity),
    id: activity.id,
    requestId: activity.request?.id,
    title: activity.title,
  }
}

export function getBirdviewDocFlowsFilters() {
  return {
    [FILTER_NAME_SUB_MENU]: SUBMENU_DEFAULT_VALUE,
    [STATUS_FILTER_NAME]: BIRDVIEW_DOC_FLOW_OPEN_STATUSES,
  }
}

export function toBirdviewDocFlowItem(docFlow) {
  return {
    id: docFlow.id,
    phase: docFlow.phase,
    status: docFlow.status,
    title: docFlow.name,
  }
}
